<ep-sub-panel [form]="form" panelType="transparent">
  <form [formGroup]="form" [evaluatedFormRules]="evaluatedFormRules">
    <ep-field-block>
      <ep-field-section *ngIf="taskActionOptions.editTaskInfo">
        <ep-field
          columnSpan="6"
          label="Subject"
          format="textbox-4099"
          [options]="{ rows: 3 }"
          controlPath="Task.Task_Desc"
        ></ep-field>
      </ep-field-section>

      <ep-field-section *ngIf="taskActionOptions.editTaskInfo">
        <ep-field-group>
          <ep-field label="Active Date" format="date" controlPath="Task.Active_Date"></ep-field>

          <ep-field
            label="Active Date Quick Select"
            hideLabel="true"
            format="dropdownSelector"
            [options]="{
              codeValues: _quickSelectDateCodes
            }"
            controlPath="Task.Active_Date_Quick_Select"
          ></ep-field>
        </ep-field-group>
        <ep-field-group>
          <ep-field label="Due Date" format="date" controlPath="Task.Late_Date"></ep-field>
          <ep-field
            label="Late Date Quick Select"
            hideLabel="true"
            format="dropdownSelector"
            [options]="{
              codeValues: _quickSelectDateCodes
            }"
            controlPath="Task.Late_Date_Quick_Select"
          ></ep-field>
          <ep-field label="Protect Due Date" format="checkbox-YN" controlPath="Task.Protect_Late_Ind"></ep-field>
        </ep-field-group>
      </ep-field-section>

      <ep-field-section *ngIf="taskActionOptions.editTaskInfo">
        <ep-field
          label="Priority"
          format="dropdownSelector"
          controlPath="Task.Priority"
          [options]="{
            codeValues: [
              { Code: '1', Code_Desc: '1 - High' },
              { Code: '2', Code_Desc: '2 - Normal' },
              { Code: '3', Code_Desc: '3 - Low' }
            ]
          }"
        >
        </ep-field>
        <ep-field label="Category" format="dropdownSelector-MinorCategory" controlPath="Task.Category"></ep-field>
      </ep-field-section>

      <ep-field-section *ngIf="taskActionOptions.editNote">
        <ep-field
          columnSpan="6"
          label="Note"
          format="textbox-4099"
          [options]="{ rows: 6 }"
          controlPath="Task.Task_Note"
        ></ep-field>
      </ep-field-section>

      <ng-container *ngIf="taskActionOptions.editRoute">
        <ep-field-section>
          <ep-field
            columnSpan="6"
            label="Route To"
            collapseTitleArea="true"
            format="radiogroup"
            [options]="{ codeValues: _routeToValues }"
            controlPath="Task.Route.Assign_To.Assign_To_Type"
          >
          </ep-field>
          <ep-field
            *ngIf="getControlValue('Task.Route.Assign_To.Assign_To_Type') == 'USER'"
            columnSpan="6"
            label="User"
            collapseLabelArea="true"
            format="search-employee"
            controlPath="Task.Route.Assign_To.User_Entity_ID"
            descControlPath="Task.Route.Assign_To.User_Entity_Name"
            [criteria]="{ Login_Acct_Status: 'A' }"
            [options]="{ autoSearch: false, allowClear: true }"
          >
          </ep-field>
          <ep-field
            *ngIf="getControlValue('Task.Route.Assign_To.Assign_To_Type') == 'WORKGROUP'"
            columnSpan="6"
            label="WorkGroup"
            collapseLabelArea="true"
            format="search-workgroup"
            controlPath="Task.Route.Assign_To.WorkGroup_ID"
            descControlPath="Task.Route.Assign_To.WorkGroup_Name"
            [options]="{ autoSearch: false, allowClear: true }"
            [criteria]="{}"
          >
          </ep-field>
          <ep-field
            *ngIf="getControlValue('Task.Route.Assign_To.Assign_To_Type') == 'AUTOASSIST'"
            columnSpan="6"
            label="Automated Assistant"
            collapseLabelArea="true"
            format="container"
          >
            <ep-field columnSpan="2" label="Routing Options"></ep-field>
            <div *ngFor="let option of _autoAssistRoutingOptions">
              <ep-field
                columnSpan="2"
                [label]="option.Label"
                format="checkbox-YN"
                [controlPath]="option.ControlPath"
              ></ep-field>
            </div>
          </ep-field>

          <ep-field
            columnSpan="6"
            label="Routing Instructions"
            format="textbox-4099"
            [options]="{ rows: 6 }"
            controlPath="Task.Route.Assign_Note"
          ></ep-field>
        </ep-field-section>
        <!--<ep-field-section>
          <ep-field-group>
            <ep-field
              columnSpan="2"
              label="Notify Assignee via Email"
              collapseLabelArea="true"
              format="checkbox-yn"
              controlPath="Task.Route.Notify_Immediate_Ind"
            ></ep-field>
            <ep-field
              columnSpan="2"
              label="Attach Document(s) to Email"
              collapseLabelArea="true"
              format="checkbox-yn"
              controlPath="Task.Route.Notify_Include_Document_Ind"
            ></ep-field>
          </ep-field-group>
          <ep-field
            columnSpan="2"
            label="Notify Me When Done"
            collapseLabelArea="true"
            format="checkbox-yn"
            controlPath="Task.Route.Notify_Complete_Ind"
          ></ep-field>
          <ep-field
            columnSpan="2"
            label="Notify Me If Late"
            collapseLabelArea="true"
            format="checkbox-yn"
            controlPath="Task.Route.Notify_Late_Ind"
          ></ep-field>
        </ep-field-section>-->
      </ng-container>

      <ep-field-section *ngIf="taskActionOptions.editProjectInfo">
        <ep-field
          columnSpan="3"
          label="Owner"
          format="search-employee"
          [criteria]="{ Login_Acct_Status: 'A' }"
          [options]="{ autoSearch: false, allowClear: false }"
          controlPath="Project.Project_Owner.Entity_ID"
          descControlPath="Project.Project_Owner.Entity_Name"
        ></ep-field>

        <ep-field columnSpan="6" label="Project Desc" format="textbox-80" controlPath="Project.Project_Desc"></ep-field>
      </ep-field-section>
    </ep-field-block>
  </form>
  <!--{{ taskActionOptions | json}}-->
</ep-sub-panel>
